export default __webpack_public_path__ + "static/media/airdockz-blk-1.8c41d5d0.png";